const AiUwCheckbox = ({ id, checked, disabled, onChange, children, className, isAttachedIcon }) => {
  return (
    <label className={`custom-control custom-checkbox ${className ? className : ''}`}>
      <input
        className="custom-control-input"
        id={id ? `checkbox${id}` : undefined}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      {isAttachedIcon ? (
        <>
          <span className="custom-control-indicator" />
          <span className={`custom-control-indicator-aiuw ${isAttachedIcon ? 'aiuw-acknowledge-icon' : ''}`} />
          <span className={isAttachedIcon ? 'aiuw-text' : ''}>{children}</span>
        </>
      ) : (
        <span className="custom-control-indicator">{children}</span>
      )}
    </label>
  )
}

export default AiUwCheckbox
